export const AUTOHIDE_HOME_SECTION_AFTER_DAYS = 30;
